import React from 'react';
import { NavLink } from 'react-router-dom';
import './Nav.css';

function Nav() {
  return (
    <nav className="nav">
      <NavLink to="/" className="nav__brand" end>
        Modern Cars
      </NavLink>
      <div className="nav__links">
        <NavLink to="/fleet" className="nav__link">
          Fleet
        </NavLink>
        <NavLink to="/about" className="nav__link">
          About
        </NavLink>
      </div>
    </nav>
  );
}

export default Nav;
